// @material-ui/icons
import {
  Assignment,
  Business,
  CloudUpload,
  Dashboard,
  PersonAdd,
  RecentActors,
  AssignmentInd,
  SupervisorAccount,
  Work,
  Assessment,
  Build,
  Settings,
  InsertChart,
  PersonAddAlt1,
} from "@mui/icons-material";

type SidebarItem = {
  path: string;
  icon: any;
};

type SidebarConfig = {
  buyer: Record<string, SidebarItem>;
  supplier: Record<string, SidebarItem>;
  "suppliers - primary contact": Record<string, SidebarItem>;
  worker: Record<string, SidebarItem>;
};

const sidebarPathsAndIcons: SidebarConfig = {
  buyer: {
    dashboard: { path: "/dashboard", icon: Dashboard },
    "external-dashboard": {
      path: "/externalDashboard",
      icon: InsertChart,
    },
    "activity-item-settings": {
      path: "/activity-item-settings/list",
      icon: Settings,
    },
    suppliers: { path: "/suppliers/list", icon: Business },
    subcontractors: { path: "/subcontractors/list", icon: RecentActors },
    sows: { path: "/sows/list", icon: Assignment },
    "sows-admin": { path: "/sowsAdm", icon: AssignmentInd },
    workers: { path: "/workers/list", icon: Work },
    equipments: { path: "/equipments", icon: Build },
    reports: { path: "/reports/list", icon: Assessment },
    workflowStatus: { path: "/workflowStatus/list", icon: Assignment },
    "bulk-upload": { path: "/data/upload", icon: CloudUpload },
    users: { path: "/users", icon: PersonAddAlt1 },
  },
  supplier: {
    dashboard: { path: "/dashboard", icon: Dashboard },
    externalDashboard: { path: "/externalDashboard", icon: InsertChart },
    "my-profile": { path: "/suppliers/profile", icon: SupervisorAccount },
    "sows-admin": { path: "/sowsAdm", icon: AssignmentInd },
    sows: { path: "/sows/list", icon: Assignment },
    subcontractors: { path: "/subcontractors/list", icon: RecentActors },
    workers: { path: "/workers/list", icon: Work },
    equipments: { path: "/equipments", icon: Build },
    "bulk-upload": { path: "/data/upload", icon: CloudUpload },
    reports: { path: "/reports/list", icon: Assessment },
    workflowStatus: { path: "/workflowStatus/list", icon: Assignment },
  },
  "suppliers - primary contact": {
    users: { path: "/users", icon: PersonAdd },
  },
  worker: {
    dashboard: { path: "/dashboard", icon: Dashboard },
    "my-profile": { path: "/workers/profile", icon: Work },
  },
};

export { sidebarPathsAndIcons };
